'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';
import { getPermissionMapping } from './permissionMapping';
import Cookies from "js-cookie";
import { env } from '../env';

type AccessControl = {
    [key: string]: { [key: string]: { R: string } };
};

type PermissionContextType = {
    permissions: {
        success: boolean;
        access_controls: AccessControl;
    } | null;
    loading: boolean;
};

const PermissionContext = createContext<PermissionContextType>({ permissions: null, loading: true });

export function PermissionProvider({ children }: { children: React.ReactNode }) {
    const [permissions, setPermissions] = useState<PermissionContextType['permissions']>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPermissions = async () => {
            setLoading(true); // Start loading

            try {
                // Replace this with your actual API endpoint
                //const response = await fetch('/api/access');
                // const data = await response.json();
                const token = Cookies.get('accessToken');
                const pr_url = `${env.GLOBAL_API_URL}/api/v1/settings/access-controls/`;
                const pr_key = env.PERMISSION_KEY;
                const product_code = env.PRODUCT_CODE;
                const response = await fetch(pr_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        "product_code": product_code,
                        "token": token
                    })
                });
                const data = await response.json();
                if (data.statusCode == '200') {
                    setPermissions(data.body);
                } else {
                    console.error('Error fetching permissions');
                }
            } catch (error) {
                console.error('Error fetching permissions:', error);
            }
            finally {
                setLoading(false); // End loading
            }
        };

        fetchPermissions();
    }, []);

    return (
        <PermissionContext.Provider value={{ permissions,loading  }}>
            {children}
        </PermissionContext.Provider>
    );
}
export function usePermissionsContext() {
    return useContext(PermissionContext);
}

export const getProductCode = () => {
    return env.PRODUCT_CODE;
};
export function usePermission(permissionKey: string): boolean | 'loading' {
    const { permissions,loading  } = useContext(PermissionContext);
    if (loading) return 'loading';

    const mapping = getPermissionMapping(permissionKey);
    // if (!permissions || !permissions.success || !mapping) return false; //For Demo Env Uncomment this Line
    if (!permissions || !permissions.success || !mapping) return false;   // For Local Env Uncomment this Line (dont push this)


    const controller = permissions.access_controls[mapping.controller];
    // if (!controller) return false; //For Demo Env Uncomment this Line
    if (!controller) return false;  // For Local Env Uncomment this Line (dont push this)


    return !!controller[mapping.function];  // For Demo Env Uncomment this Line
    return false; // For Local Env Uncomment this Line (dont push this)
}
